/**
 * Internals
 */
const accountActivities = require('./account-activities');
const accountPermissions = require('./account-permissions');
const accountPrinters = require('./account-printers');
const accountSessions = require('./account-sessions');
const accountWorkers = require('./account-workers');
const accounts = require('./accounts');
const customerDealSchedules = require('./customer-deal-schedules');
const customerDealerEatLimits = require('./customer-dealer-eat-limits');
const customerDealerFights = require('./customer-dealer-fights');
const customerDealerProperties = require('./customer-dealer-properties');
const customerDealerTankLimits = require('./customer-dealer-tank-limits');
const customerDownlines = require('./customer-downlines');
const customerPartners = require('./customer-partners');
const customerProperties = require('./customer-properties');
const customerRequestLimits = require('./customer-request-limits');
const customerRewardLimits = require('./customer-reward-limits');
const customerRunnerContractDiscounts = require('./customer-runner-contract-discounts');
const customerRunnerContractPayouts = require('./customer-runner-contract-payouts');
const customerRunnerContracts = require('./customer-runner-contracts');
const customerRunnerProperties = require('./customer-runner-properties');
const customerRunnerTicketAddonEntries = require('./customer-runner-ticket-addon-entries');
const customerRunnerTicketAddons = require('./customer-runner-ticket-addons');
const customerRunnerTicketConversions = require('./customer-runner-ticket-conversions');
const customerRunnerTicketHookEntries = require('./customer-runner-ticket-hook-entries');
const customerRunnerTicketHooks = require('./customer-runner-ticket-hooks');
const customerRunnerTicketSchemeEntries = require('./customer-runner-ticket-scheme-entries');
const customerRunnerTicketSchemes = require('./customer-runner-ticket-schemes');
const customerSystemGameTypes = require('./customer-system-game-types');
const customerSystemTicketNumberPlugins = require('./customer-system-ticket-number-plugins');
const customers = require('./customers');
const dealLimits = require('./deal-limits');
const dealReceipts = require('./deal-receipts');
const deals = require('./deals');
const drawSystemGameTypeInvoices = require('./draw-system-game-type-invoices');
const drawSystemGameTypeReports = require('./draw-system-game-type-reports');
const drawSystemGameTypeResults = require('./draw-system-game-type-results');
const drawSystemGameTypes = require('./draw-system-game-types');
const drawSystemGames = require('./draw-system-games');
const draws = require('./draws');
const systemGameCategories = require('./system-game-categories');
const systemGamePrizes = require('./system-game-prizes');
const systemGameTypes = require('./system-game-types');
const systemGames = require('./system-games');
const systemPermissions = require('./system-permissions');
const systemTicketNumberPlugins = require('./system-ticket-number-plugins');
const systemTranslations = require('./system-translations');
const systems = require('./systems');
const utilities = require('./utilities');

module.exports = {
  accountActivities,
  accountPermissions,
  accountPrinters,
  accountSessions,
  accountWorkers,
  accounts,
  customerDealSchedules,
  customerDealerEatLimits,
  customerDealerFights,
  customerDealerProperties,
  customerDealerTankLimits,
  customerDownlines,
  customerPartners,
  customerProperties,
  customerRequestLimits,
  customerRewardLimits,
  customerRunnerContractDiscounts,
  customerRunnerContractPayouts,
  customerRunnerContracts,
  customerRunnerProperties,
  customerRunnerTicketAddonEntries,
  customerRunnerTicketAddons,
  customerRunnerTicketConversions,
  customerRunnerTicketHookEntries,
  customerRunnerTicketHooks,
  customerRunnerTicketSchemeEntries,
  customerRunnerTicketSchemes,
  customerSystemGameTypes,
  customerSystemTicketNumberPlugins,
  customers,
  dealLimits,
  dealReceipts,
  deals,
  drawSystemGameTypeInvoices,
  drawSystemGameTypeReports,
  drawSystemGameTypeResults,
  drawSystemGameTypes,
  drawSystemGames,
  draws,
  systemGameCategories,
  systemGamePrizes,
  systemGameTypes,
  systemGames,
  systemPermissions,
  systemTicketNumberPlugins,
  systemTranslations,
  systems,
  utilities,
};
